import URLShortener from "./components/URLShortener"

let module = "frontend"

export default [
  {
    path: "url/:token",
    component: URLShortener,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
